export default __webpack_public_path__ + "images/a339b925f1bcc64b397540f0ea75bc00-hightech.jpg";